<span class="pointer-events-none">
  <ng-content></ng-content>
</span>
